export var ABTestAnalyticsState;
(function (ABTestAnalyticsState) {
    ABTestAnalyticsState[ABTestAnalyticsState["FirstAssignment"] = 0] = "FirstAssignment";
    ABTestAnalyticsState[ABTestAnalyticsState["Assigned"] = 1] = "Assigned";
    ABTestAnalyticsState[ABTestAnalyticsState["Exited"] = 2] = "Exited";
})(ABTestAnalyticsState || (ABTestAnalyticsState = {}));
